// extracted by mini-css-extract-plugin
module.exports = {"hexagon":"style_hexagon__2xYDj","imageText":"style_imageText__1fw6C"};